import notifications from 'shared/childupp-notifications';

(function (upp) {
    'use strict';

    upp.controller('upp.notifications.NotificationsCtrl', ['$scope', '$rootScope', 'appi', 'notificationsService',
        function ($scope, $rootScope, appi, notificationsService) {
            appi.ui.changeActualOption({moduleKey2Display: 'notifications', navbarKey: 'notifications'});
            appi.ui.showPageLoadingMsg();

            $scope.hasPermission = notifications.hasPermission();

            notificationsService.getNotifications()
                .then(function (notifications) {
                    $scope.notifications = notifications;
                    $rootScope.numNotifications = 0;
                    appi.ui.hidePageLoadingMsg();
                }, function () {
                    appi.ui.showNetworkError();
                });
        }
    ]);

}(upp));



// WEBPACK FOOTER //
// ./src/app/modules/notifications/controllers/notifications-controller.js